
(function(window, $){

    $(".card-prod-options .color-option-btn").on("click", function(){
        var elem = $(this);
        var parantId = elem.attr("data-parent-prod");
        var escapedPriceHtml = elem.attr("data-prod-price");
        var parantElem = $(`.card-prod-wrap[data-prod-id="${parantId}"]`);
        var priceElem = parantElem.find(".card-prod-price");
        var linkElem = parantElem.find(".prod-card-link");
        var titleElem = parantElem.find(".card-prod-heading");


        var decoder = document.createElement('textarea');
        decoder.innerHTML = escapedPriceHtml;
        var decodedPriceHtml = decoder.value;
        parantElem.find(".card-prod-media-wrap img").attr("src", elem.attr("data-prod-img"));
        priceElem.html(decodedPriceHtml);
        linkElem.attr("href", elem.attr("data-prod-url"));
        titleElem.text(elem.attr("data-prod-title"));
        $(`.color-option-btn[data-parent-prod="${parantId}"].selected`).removeClass("selected");
        elem.addClass("selected");
        
    });

})(window, jQuery);